export const Open = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      
    <path
      d="M12.0002 14.071L8.17915 10.25C7.76515 9.83595 7.09315 9.83595 6.67915 10.25C6.26515 10.664 6.26515 11.336 6.67915 11.75L11.2932 16.364C11.6842 16.755 12.3172 16.755 12.7072 16.364L17.3212 11.75C17.7352 11.336 17.7352 10.664 17.3212 10.25C16.9072 9.83595 16.2352 9.83595 15.8212 10.25L12.0002 14.071Z"
      fill="#122B46"
    />
  </svg>
)
